import MainVisual from "./classes/mainvisual.es6";
import News from "./classes/news.es6";
import Character from "./classes/character.es6";

export default class Main {
    constructor() {
        this.mainvisual = new MainVisual();
        this.character = new Character();
        this.news = new News();
    }
}
